import React, { FunctionComponent } from 'react';
import { EventDetailProps, EventDetailState } from './types';
import { EventContentsSection } from '../../organisms/eventContentsSection';
import { CompanyInfoHeader } from '../../molecules/companyInfoHeader';
import { EventDetailInfo } from '../../molecules/eventDetailInfo';
import { EventDetailCompanySection } from '../../organisms/eventDetailCompanySection';
import { EventShareButtons } from '../../molecules/eventShareButtons';
import { RelatedRecruitmentsList } from '../../organisms/relatedRecruitmentsList'
import { RelatedEventsList } from '../../organisms/relatedEventsList';
type Props = Pick<EventDetailProps, 'assetPaths'> & {
  state: EventDetailState;
};

export const Presentation: FunctionComponent<Props> = ({ state, assetPaths }) => {
  if (!state.data) return null;

  const { event, company, eventContents, currentUser } = state.data;

  return (
    <>
      <div className="single-ttl">
        <CompanyInfoHeader
          companyId={company.id}
          companyName={company.name}
          companyIcon={company.icon}
          noImagePath={assetPaths.noImage}
        />

        <div className="article-info">
          <h1 className="article-info-title">{event.title}</h1>
          <div className="hero-label-category">
            <h2>イベント</h2>
            <i className="fas fa-map-marker-alt"></i>
            <p>{eventContents[0]?.place || ''}</p>
          </div>
        </div>
      </div>

      <div className="single-hero">
        <img src={event.image || assetPaths.noImage} alt="カバーの写真" />
      </div>

      <section className="l-single-body u-clear">
        <div className="l-single-article u-clear">
          <div className="l-single-article-container u-clear">
            <div className="l-single-article-inner--first">
              <section className="article-section article-section-event" id="article-01">
                <div className="article-section-info">詳細・内容</div>
                <p style={{ whiteSpace: 'pre-wrap' }}>
                  {event.body}
                </p>
                <EventContentsSection
                  eventId={event.id}
                  eventTitle={event.title}
                  eventContents={eventContents}
                  currentUser={currentUser}
                  lineIcon={assetPaths.lineIcon}
                />
                <EventDetailInfo
                  title={event.title}
                  locations={event.event_locations}
                  requirement={event.requirement}
                />
                <EventDetailCompanySection
                  company={company}
                  noImage={assetPaths.noImage}
                />
              </section>
            </div>
          </div>
        </div>
      </section>

      <div className="l-single-article u-clear">
        <div className="l-single-article-container l-single-article-container-last u-clear">
          <div className="l-single-article-inner-event u-clear">
            <EventShareButtons
              eventTitle={event.title}
              eventUrl={window.location.href}
            />
          </div>
        </div>
      </div>
      <RelatedRecruitmentsList eventId={event.id} />
      <RelatedEventsList eventId={event.id} />
    </>
  );
};
